import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../public/assets/icon/sidebar/sidebar-cnpjcard.svg'
import _imports_1 from '../../public/assets/icon/sidebar/sidebar-meibenefits.svg'
import _imports_2 from '../../public/assets/icon/sidebar/sidebar-contacts.svg'
import _imports_3 from '../../public/assets/icon/sidebar/sidebar-educationalmaterials.svg'
import _imports_4 from '../../public/assets/icon/sidebar/sidebar-notifications.svg'
import _imports_5 from '../../public/assets/icon/sidebar/sidebar-indicate.svg'
import _imports_6 from '../../public/assets/icon/sidebar/sidebar-evaluate.svg'


const _hoisted_1 = { class: "flex px-7 pb-3 pt-5 items-center justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "w-14 h-14 bg-blue-500 text-white rounded-full text-center pt-3 text-2xl min-w-[3.5rem]" }
const _hoisted_4 = { class: "font-semibold pl-2 pt-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "text-slate-600 underline pl-2" }, " Editar perfil ", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex items-center ml-12 pt-1" }
const _hoisted_8 = { class: "flex flex-col bg-white ion-padding h-full relative w-full" }
const _hoisted_9 = { class: "bg-white" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-6"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", { class: "ml-3 font-semibold text-sm" }, " Cartão CNPJ ", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-6"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", { class: "ml-3 font-semibold text-sm" }, " Benefícios MEI ", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-6"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", { class: "ml-3 font-semibold text-sm" }, " Contatos ", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "ion-text-wrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-6"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", { class: "ml-3 font-semibold text-sm" }, " Materiais Educativos ", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "w-6"
}, null, -1)
const _hoisted_25 = { class: "ml-3 font-semibold text-sm" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Notificações ")
const _hoisted_27 = {
  key: 0,
  class: "bg-red-500 rounded-md py-0.5 px-1.5 text-xs"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "w-6"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", { class: "ml-3 font-semibold text-sm" }, " Indique ", -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "w-6"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", { class: "ml-3 font-semibold text-sm" }, " Avalie ", -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "flex justify-between mt-auto bottom-5 w-full absolute" }
const _hoisted_36 = ["onClick"]

import {
	IonHeader,
	IonToolbar,
	IonContent,
	IonMenu,
	IonPage,
	useIonRouter,
	menuController,
	IonList,
	IonItem,
	IonIcon,
	isPlatform,
} from "@ionic/vue";
import { closeOutline } from "ionicons/icons";
import { useUser } from "@/composables/user";
import { computed } from "vue";
import { Share } from "@capacitor/share";
import ServiceButtons from "@/components/ServiceButtons.vue";
import { useNotifications } from "@/composables/notifications";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenu',
  setup(__props) {

const ionRouter = useIonRouter();
const { logout, user } = useUser();
const firstletter = computed(() => user.value?.name[0].toUpperCase());

function shareApp() {
	Share.share({
		title: "Conhece o GerenciaMei?",
		text:
			`Conhece o GerenciaMei?\n` +
			`Há um tempo eu venho organizando as DAS da minha MEI com um aplicativo chamado GerenciaMei e está sendo ótimo! Hoje eu resolvi indicar para alguns amigos, e lembrei de você. Testa lá, e me diz o que você acha.É grátis, sem compromisso.`,
		url: "https://gerenciamei.com/",
	});
}

const handleLogoutClick = async () => {
	await logout();
	await menuController.close();
	ionRouter.navigate("/login");
};

const handleOpenRoute = async (route: string) => {
	await menuController.close();
	ionRouter.push(route);
};

const redirectStore = async () => {
	if (isPlatform("ios"))
		window.location.href =
			"https://apps.apple.com/br/app/gerenciamei-abrir-cnpj-das/id6444381743";
	if (isPlatform("android"))
		window.location.href =
			"https://play.google.com/store/apps/details?id=com.gerenciamei";
	if (!isPlatform("ios") && !isPlatform("android")) {
		window.location.href =
			"https://play.google.com/store/apps/details?id=com.gerenciamei";
	}
};

const { unread } = useNotifications();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonMenu), { "content-id": "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonHeader), { class: "ion-no-border" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonToolbar), {
              color: "white",
              class: "h-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(firstletter)), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(user)?.name), 1),
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleOpenRoute('/profile/edit')), ["prevent"]))
                      }, _hoisted_6)
                    ])
                  ]),
                  _createElementVNode("button", _hoisted_7, [
                    _createVNode(_unref(IonIcon), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(menuController).close())),
                      icon: _unref(closeOutline),
                      class: "text-2xl"
                    }, null, 8, ["icon"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonContent), { class: "content" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(ServiceButtons)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(IonList), {
                  lines: "none",
                  class: "flex flex-col items-start justify-center border-t mt-4"
                }, {
                  default: _withCtx(() => [
                    (_unref(user)?.cnpj)
                      ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleOpenRoute('/cnpj-card')), ["prevent"])),
                              class: "flex items-center"
                            }, _hoisted_13)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(user)?.cnpj)
                      ? (_openBlock(), _createBlock(_unref(IonItem), { key: 1 }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleOpenRoute('benefits')), ["prevent"])),
                              class: "flex items-center"
                            }, _hoisted_16)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleOpenRoute('/contacts')), ["prevent"])),
                          class: "flex items-center"
                        }, _hoisted_19)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("a", {
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
										handleOpenRoute('/learn-it')
									), ["prevent"])),
                            class: "flex items-center"
                          }, _hoisted_23)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonList), {
                  lines: "none",
                  class: "flex flex-col items-start justify-center border-t"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (
									handleOpenRoute('/notifications')
								), ["prevent"])),
                          class: "flex items-center"
                        }, [
                          _hoisted_24,
                          _createElementVNode("button", _hoisted_25, [
                            _hoisted_26,
                            (_unref(unread) != 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(unread)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _withModifiers(shareApp, ["prevent"]),
                          class: "flex items-center"
                        }, _hoisted_31, 8, _hoisted_28)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: redirectStore,
                          class: "flex items-center"
                        }, _hoisted_34)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (handleOpenRoute('/terms-of-use')), ["prevent"])),
                    class: "text-xs uppercase underline text-zinc-600"
                  }, " Termos de uso "),
                  _createElementVNode("a", {
                    href: "",
                    class: "text-xs uppercase underline text-zinc-600 pr-8",
                    onClick: _withModifiers(handleLogoutClick, ["prevent"])
                  }, " Sair do app ", 8, _hoisted_36)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonPage), { id: "main-content" })
  ], 64))
}
}

})